import Image from 'next/image'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { useMyProfileApi } from '~/features/profile/hooks/my_profile/useMyProfileApi'
import { autoPlayState } from '~/features/setting/store'
import { useLogger } from '../../useLogger'
import { useVideoScale } from '../../useVideoScale'
import { PlayerButton } from '../PlayerButton'

type Props = {}

export const AutoPlay = ({}: Props) => {
  const { videoScale } = useVideoScale()
  const { t } = useTranslation()
  const { clickAutoPlayButton } = useLogger()

  const { updateAutoPlay } = useMyProfileApi()
  const [autoPlay, setAutoPlay] = useRecoilState(autoPlayState)

  const handleChangeAutoPlay = useCallback(async () => {
    setAutoPlay(!autoPlay)
    await updateAutoPlay(!autoPlay)
    clickAutoPlayButton(!autoPlay ? 'on' : 'off')
  }, [setAutoPlay, updateAutoPlay, autoPlay, clickAutoPlayButton])

  return (
    <div style={{ position: 'relative' }}>
      <PlayerButton onClick={handleChangeAutoPlay}>
        <div
          style={{
            position: 'relative',
          }}
        >
          <Image
            src='/player/autoplay_bar.png'
            alt='Autoplay'
            width={videoScale * 78}
            height={videoScale * 26}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: autoPlay ? '100%' : '0%',
              transform: `translate(${autoPlay ? '-100%' : '0%'}, -50%)`,
              width: `${videoScale * 52}px`,
              height: `${videoScale * 52}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: autoPlay ? 1 : 0,
              transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
            }}
          >
            <Image
              src='/player/autoplay_on.png'
              alt='Autoplay On'
              width={videoScale * 52}
              height={videoScale * 52}
            />
          </div>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: autoPlay ? '100%' : '0%',
              transform: `translate(${autoPlay ? '-100%' : '0%'}, -50%)`,
              width: `${videoScale * 52}px`,
              height: `${videoScale * 52}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: autoPlay ? 0 : 1,
              transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
            }}
          >
            <Image
              src='/player/autoplay_off.png'
              alt='Autoplay Off'
              width={videoScale * 52}
              height={videoScale * 52}
            />
          </div>
        </div>
        {videoScale > 0.4 && (
          <span
            style={{
              fontSize: `${videoScale * 24}px`,
              fontWeight: 'bold',
              marginLeft: '8px',
            }}
          >
            {autoPlay ? t('Autoplay On') : t('Autoplay Off')}
          </span>
        )}
      </PlayerButton>
    </div>
  )
}
